import { useState } from "react";

import { useNavigate } from "react-router";

export function useDiscardBlocker({ allowedPaths }: { allowedPaths: string[] }) {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pendingPath, setPendingPath] = useState<string | null>(null);

  const requestNavigation = (path: string) => {
    if (allowedPaths.includes(path)) {
      navigate(path);
    } else {
      setPendingPath(path);
      setIsModalOpen(true);
    }
  };

  const handleDiscard = () => {
    setIsModalOpen(false);
    if (pendingPath) {
      navigate(pendingPath);
      setPendingPath(null);
    }
  };

  const handleNotDiscard = () => {
    setIsModalOpen(false);
    setPendingPath(null);
  };

  return { isModalOpen, handleDiscard, handleNotDiscard, requestNavigation };
}
